.root {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}
